<template>
  <main id="deliver-to-loads-main">
    <account-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" :accountType="consignees"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('outbound.loads.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="historical-caption-row" :hidden="true">
        <el-col>
          <i class="el-icon-info red-armellini"></i>&nbsp;
          <span class="font-gray info-text"> {{ $t('outbound.loads.historical') }} &nbsp;</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="red-link-bold"
            :href="aelis2HistoricalUrl"
          >
            {{ $t('common.here') }}
          </a>
        </el-col>
      </el-row>
      <el-row v-if="isConsigneeSmsOff">
        <el-col>
          <i class="el-icon-info"></i>&nbsp;
          <span class="font-gray info-text"> {{ $t('common.signUpEtaSms') }} &nbsp;</span>
          <AgreementDialog :accountId="currentAccountId" :currentPhone="currentAccountPhone" :isLink="true"/>
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" :xs="24" class="default-section-title">
              {{ $t('outbound.loads.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col v-if="device==='mobile'">
              <search-summary-mobile />
            </el-col>
            <el-col v-else>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';
import AccountList from '@/components/AccountList';
import { LOADS_DELIVER_TO_SEARCH } from '@/store/actions';
import adminSettingsService from '@/api/adminSettingsService';
import AgreementDialog from '@/views/customerService/profile/agreement';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import SearchSummaryMobile from './SearchSummaryMobile';

export default {
  name: 'DeliverToLoads',
  components: {
    SearchFilter,
    SearchSummary,
    SearchSummaryMobile,
    AccountList,
    AgreementDialog
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    aelis2HistoricalUrl: () => constants.AELIS2.URLS.CONSIGNEE_LOADS,
    isConsigneeSmsOff() {
      return !this.$store.state.user.smsOn;
    },
    currentAccountId() {
      return this.$store.state.user.accountId;
    },
    currentAccountPhone() {
      return this.$store.state.user.accountPhoneNumber;
    },
  },
  data() {
    return {
      actionMountChained: ['loads/setDeliverToLoadsDefaultFilters'],
      actionSelectChained: [LOADS_DELIVER_TO_SEARCH],
      consignees: constants.ACCOUNTS.TYPE[2].value,
      salesforceSmsSingUpUrl: 'http://'
    };
  },
  mounted() {
    const filter = {
      value: 'saleforceSmsRegisterUrl'
    };
    adminSettingsService.search(filter).then((res) => { this.salesforceSmsSingUpUrl = res.data[0].value; });
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
main#deliver-to-loads-main {
  .search-summary-container {
    margin-top: 5px;
  }
}
</style>
